import Container from "../../components/menu/Container";
import { useTranslation } from "react-i18next";
import { maskCpfCnpj } from "../../utils/ValidationUtils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useEffect, useState } from "react";
import findConsulta from "../../service/findConsulta";
import getConsultaDownloadResponse from "../../service/getConsultaDownloadResponse";
import React from "react";
import { Toolbar } from "primereact/toolbar";
import { Calendar } from "primereact/calendar";
import { Nullable } from "primereact/ts-helpers";
import { SortOrder } from 'primereact/api';
import { Button } from 'primereact/button';
import './consultas.css'
import { InputText } from 'primereact/inputtext';
import { useGlobalState } from '../../components/globalState/GlobalStateProvider';
import findClient from "../../service/findClient";
import { Dropdown } from "primereact/dropdown";
import { TreeSelect, TreeSelectSelectionKeysType } from "primereact/treeselect";


export default function HistoricoPage() {
  const { t } = useTranslation();
  const [consultas, setConsultas] = useState(undefined);
  const [totalRecords, setTotalRecords] = useState(0);
  const [usuario, setUsuario] = useState<Nullable<String | null>>(null);
  const [documento, setDocumento] = useState<Nullable<String | null>>(null);
  const [data, setData] = useState<Nullable<Date>>(new Date());
  const [dataFinal, setDataFinal] = useState<Nullable<Date>>(new Date());
  const { state } = useGlobalState();
  const [selectedClient, setSelectedClient] = useState<any>(null);
  const [clients, setClients] = useState<any>([]);
  const [expandedRows, setExpandedRows] = useState(undefined);
  const [selectedNodeKey, setSelectedNodeKey] = useState<Nullable<string | TreeSelectSelectionKeysType | TreeSelectSelectionKeysType[]>>();
  const [selectedErro, setselectedErro] = useState<any>({ name: "Não filtrado", code: null });
  const [selectedCache, setselectedCache] = useState<any>({ name: "Não filtrado", code: null });

  const tiposErro = [
    { name: "Não filtrado", code: null },
    { name: "Sem Erros", code: false },
    { name: "Somente com Erros", code: true }
  ];

  const tiposCache = [
    { name: "Não filtrado", code: null },
    { name: "Sem Cache", code: false },
    { name: "Somente com Cache", code: true }
  ];

  const createOptions = () => {

    const option: any[] = [];

    state.user.consultas
      .sort((a: any, b: any) => {
          if (!a.ordenacao) {
            return 1;
          }

          if (!b.ordenacao) {
            return -1;
          }

          if (a.ordenacao > b.ordenacao) {
            return 1;
          }
          if (a.ordenacao < b.ordenacao) {
            return -1;
          }
          return 0;
      })
      .forEach((element: any) => {
        const filhos = element.permissoes ? element.permissoes : [];
        if (filhos.length > 0) {
          option.push({ root: true, informativo: element.informativo, label: element.label, key: element.value, Collapse: true, children: createPermissoesFilhos(filhos, true) });
        }

      });

    return option;
  }

  const createPermissoesFilhos = (permissoes: any[], first: boolean) => {
    const option: any[] = [];
    if (permissoes) {
      permissoes
        .sort((a: any, b: any) => {
            if (!a.ordenacao) {
              return 1;
            }

            if (!b.ordenacao) {
              return -1;
            }

            if (a.ordenacao > b.ordenacao) {
              return 1;
            }
            if (a.ordenacao < b.ordenacao) {
              return -1;
            }
            return 0;
        })
        .forEach((element: {
          children: any; label: string; value: string; informativo: string; permissoes: any[]
        }) => {
          option.push({ label: element.label, first: first, informativo: element.informativo, key: element.value, Collapse: true, children: element.permissoes ? createPermissoesFilhos(element.permissoes, false) : [] });
        });
    }
    return option;
  }

  const padTo2Digits = (num: number) => {
    return num.toString().padStart(2, "0");
  };
  const formatDate = (date: Nullable<Date>) => {
    if (date) {
      return [
        padTo2Digits(date.getDate()),
        padTo2Digits(date.getMonth() + 1),
        date.getFullYear(),
      ].join("-");
    }
  };

  const [lazyState, setlazyState] = useState({
    first: 0,
    rows: 10,
    page: 1,
    data: formatDate(data),
    dataFinal: formatDate(dataFinal),
    usuario: usuario,
    documento: documento,
    idFranquia: state.user.franquiaSelected?.id,
    cliente: selectedClient ? selectedClient.code : null,
    agrupador: selectedNodeKey,
    filtroCache: selectedCache ? selectedCache.code : null,
    filtroErro: selectedErro ? selectedErro.code : null,
    sortField: "dataRequisicao",
    sortOrder: SortOrder.DESC,
  });

  const onPage = (event: any) => {
    setlazyState({
      first: event.first,
      rows: event.rows,
      page: event.first / event.rows + 1,
      data: formatDate(data),
      dataFinal: formatDate(dataFinal),
      usuario: usuario,
      documento: documento,
      idFranquia: state.user.franquiaSelected?.id,
      cliente: selectedClient ? selectedClient.code : null,
      agrupador: selectedNodeKey,
      filtroCache: selectedCache ? selectedCache.code : null,
      filtroErro: selectedErro ? selectedErro.code : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder,
    });
  };

  const onSort = (event: any) => {
    setlazyState({
      first: 0,
      rows: 10,
      page: 1,
      data: formatDate(data),
      dataFinal: formatDate(dataFinal),
      usuario: usuario,
      documento: documento,
      idFranquia: state.user.franquiaSelected?.id,
      cliente: selectedClient ? selectedClient.code : null,
      agrupador: selectedNodeKey,
      filtroCache: selectedCache ? selectedCache.code : null,
      filtroErro: selectedErro ? selectedErro.code : null,
      sortField: event.sortField,
      sortOrder: event.sortOrder,
    });
  };

  const changeData = (data: Nullable<Date>) => {
    if (data) {
      setData(data);
      setlazyState({
        first: lazyState.first,
        rows: lazyState.rows,
        page: lazyState.first / lazyState.rows + 1,
        data: formatDate(data),
        dataFinal: formatDate(dataFinal),
        usuario: usuario,
        documento: documento,
        idFranquia: state.user.franquiaSelected?.id,
        cliente: selectedClient ? selectedClient.code : null,
        agrupador: selectedNodeKey,
        filtroCache: selectedCache ? selectedCache.code : null,
        filtroErro: selectedErro ? selectedErro.code : null,
        sortField: "dataRequisicao",
        sortOrder: SortOrder.DESC,
      });
    }
  };

  const changeDataFinal = (dataFi: Nullable<Date>) => {
    if (dataFi) {
      setDataFinal(dataFi);
      setlazyState({
        first: lazyState.first,
        rows: lazyState.rows,
        page: lazyState.first / lazyState.rows + 1,
        data: formatDate(data),
        dataFinal: formatDate(dataFi),
        usuario: usuario,
        documento: documento,
        idFranquia: state.user.franquiaSelected?.id,
        cliente: selectedClient ? selectedClient.code : null,
        agrupador: selectedNodeKey,
        filtroCache: selectedCache ? selectedCache.code : null,
        filtroErro: selectedErro ? selectedErro.code : null,
        sortField: "dataRequisicao",
        sortOrder: SortOrder.DESC,
      });
    }
  };

  const changeCliente = (value: any) => {
    setSelectedClient(value);
    setlazyState({
      first: lazyState.first,
      rows: lazyState.rows,
      page: lazyState.first / lazyState.rows + 1,
      data: formatDate(data),
      dataFinal: formatDate(dataFinal),
      usuario: usuario,
      documento: documento,
      idFranquia: state.user.franquiaSelected?.id,
      cliente: value ? value.code : null,
      agrupador: selectedNodeKey,
      filtroCache: selectedCache ? selectedCache.code : null,
      filtroErro: selectedErro ? selectedErro.code : null,
      sortField: "dataRequisicao",
      sortOrder: SortOrder.DESC,
    });
  };

  const changeErro = (value: any) => {
    setselectedErro(value);
    setlazyState({
      first: lazyState.first,
      rows: lazyState.rows,
      page: lazyState.first / lazyState.rows + 1,
      data: formatDate(data),
      dataFinal: formatDate(dataFinal),
      usuario: usuario,
      documento: documento,
      idFranquia: state.user.franquiaSelected?.id,
      cliente: selectedClient ? selectedClient.code : null,
      agrupador: selectedNodeKey,
      filtroCache: selectedCache ? selectedCache.code : null,
      filtroErro: value ? value.code : null,
      sortField: "dataRequisicao",
      sortOrder: SortOrder.DESC,
    });
  };

  const changeCache = (value: any) => {
    setselectedCache(value);
    setlazyState({
      first: lazyState.first,
      rows: lazyState.rows,
      page: lazyState.first / lazyState.rows + 1,
      data: formatDate(data),
      dataFinal: formatDate(dataFinal),
      usuario: usuario,
      documento: documento,
      idFranquia: state.user.franquiaSelected?.id,
      cliente: selectedClient ? selectedClient.code : null,
      agrupador: selectedNodeKey,
      filtroCache: value ? value.code : null,
      filtroErro: selectedErro ? selectedErro.code : null,
      sortField: "dataRequisicao",
      sortOrder: SortOrder.DESC,
    });
  };

  const changeOpcao = (value: Nullable<string | TreeSelectSelectionKeysType | TreeSelectSelectionKeysType[]>) => {
    setSelectedNodeKey(value);
    setlazyState({
      first: lazyState.first,
      rows: lazyState.rows,
      page: lazyState.first / lazyState.rows + 1,
      data: formatDate(data),
      dataFinal: formatDate(dataFinal),
      usuario: usuario,
      documento: documento,
      idFranquia: state.user.franquiaSelected?.id,
      cliente: selectedClient ? selectedClient.code : null,
      agrupador: value,
      filtroCache: selectedCache ? selectedCache.code : null,
      filtroErro: selectedErro ? selectedErro.code : null,
      sortField: "dataRequisicao",
      sortOrder: SortOrder.DESC,
    });
  };

  const changeUsuario = (user: Nullable<String>) => {
    user = user ? user : null;
    setUsuario(user);
    setlazyState({
      first: lazyState.first,
      rows: lazyState.rows,
      page: lazyState.first / lazyState.rows + 1,
      data: formatDate(data),
      dataFinal: formatDate(dataFinal),
      usuario: user,
      documento: documento,
      idFranquia: state.user.franquiaSelected?.id,
      cliente: selectedClient ? selectedClient.code : null,
      agrupador: selectedNodeKey,
      filtroCache: selectedCache ? selectedCache.code : null,
      filtroErro: selectedErro ? selectedErro.code : null,
      sortField: "dataRequisicao",
      sortOrder: SortOrder.DESC,
    });
  };


  const isPlaca = (value: string): boolean => {
    const placaAntiga = /^[A-Z]{3}\d{4}$/i;
    const placaMercosul = /^[A-Z]{3}\d[A-Z]\d{2}$/i;
    return placaAntiga.test(value) || placaMercosul.test(value);
  };

  const changeDocumento = (doc: Nullable<String>) => {
    if (doc && !isPlaca(doc as string)) {
      doc = doc.replaceAll(".", "").replaceAll("-", "").replaceAll("/", "");
    } else if (!doc) {
      doc = null;
    }
    setDocumento(doc);
    setlazyState({
      first: lazyState.first,
      rows: lazyState.rows,
      page: lazyState.first / lazyState.rows + 1,
      data: formatDate(data),
      dataFinal: formatDate(dataFinal),
      usuario: usuario,
      documento: doc,
      idFranquia: state.user.franquiaSelected?.id,
      cliente: selectedClient ? selectedClient.code : null,
      agrupador: selectedNodeKey,
      filtroCache: selectedCache ? selectedCache.code : null,
      filtroErro: selectedErro ? selectedErro.code : null,
      sortField: "dataRequisicao",
      sortOrder: SortOrder.DESC,
    });
  };

  const loadLazyData = () => {
    findConsulta(lazyState)
      .then((data) => {
        setTotalRecords(data.total);
        setConsultas(data.consultas);
      })
      .catch(() => {
        setTotalRecords(0);
        setConsultas(undefined);
      });
  };
  const cols = [
    { field: 'dataRequisicao', header: 'Dt. Solicitação' },
    { field: 'ip', header: 'IP' },
    { field: 'documento', header: 'Documento' },
    { field: 'consumidor', header: 'Consumidor' },
    { field: 'usuario', header: 'Usuário' },
    { field: 'agrupador', header: 'Opção' },
    { field: 'origem', header: 'Origem' },
    { field: 'cache', header: 'Cache' }
  ];
  const exportColumns = cols.map((col) => ({ title: col.header, dataKey: col.field }));
  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const lazy = {
          first: 0,
          rows: totalRecords,
          page: 1,
          data: formatDate(data),
          dataFinal: formatDate(dataFinal),
          usuario: usuario,
          documento: documento,
          idFranquia: state.user.franquiaSelected?.id,
          cliente: selectedClient ? selectedClient.code : null,
          agrupador: selectedNodeKey,
          filtroCache: selectedCache ? selectedCache.code : null,
          filtroErro: selectedErro ? selectedErro.code : null,
          sortField: "dataRequisicao",
          sortOrder: SortOrder.DESC,
        };
        findConsulta(lazy).then((data) => {
          const doc: any = new jsPDF.default("portrait");
          doc.autoTable(exportColumns, data.consultas);
          doc.save("consultas.pdf");
        });
      });
    });
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const lazy = {
        first: 0,
        rows: totalRecords,
        page: 1,
        data: formatDate(data),
        dataFinal: formatDate(dataFinal),
        usuario: usuario,
        documento: documento,
        idFranquia: state.user.franquiaSelected?.id,
        cliente: selectedClient ? selectedClient.code : null,
        agrupador: selectedNodeKey,
        filtroCache: selectedCache ? selectedCache.code : null,
        filtroErro: selectedErro ? selectedErro.code : null,
        sortField: "dataRequisicao",
        sortOrder: SortOrder.DESC,
      };
      findConsulta(lazy).then((data) => {
        const result: any[] = [];
        data.consultas.forEach((item: any) => {
          result.push({
            data: item.dataRequisicao,
            ip: item.ip,
            usuario: item.usuario,
            filtro: item.documento,
            consumidor: item.consumidor,
            opcao: item.agrupador,
            origem: item.origem,
            valor: item.valor
          })
        })
        const worksheet = xlsx.utils.json_to_sheet(result);
        const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        const excelBuffer = xlsx.write(workbook, {
          bookType: "xlsx",
          type: "array",
        });
        saveAsExcelFile(excelBuffer, "consultas");
      });
    });
  };

  const handleDocumento = (event: any) => {
    const val: string = event.target.value;
    // Se começar com letra, é uma placa sendo digitada — não aplica máscara CPF/CNPJ
    const pareceSerPlaca = /^[A-Za-z]/.test(val);
    if (!pareceSerPlaca) {
      event.target.value = maskCpfCnpj(val);
    }
  };

  const saveAsExcelFile = (excelBuffer: any, fileName: string) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        let EXCEL_TYPE =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
        let EXCEL_EXTENSION = ".xlsx";
        const data = new Blob([excelBuffer], {
          type: EXCEL_TYPE,
        });

        module.default.saveAs(
          data,
          fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
        );
      }
    });
  };
  const header = (
    <div className="flex-consulta align-items-center justify-content-end gap-2">
      <Button
        type="button"
        icon="pi pi-file-excel"
        severity="success"
        rounded
        onClick={exportExcel}
        data-pr-tooltip="XLS"
      />
      <Button
        type="button"
        icon="pi pi-file-pdf"
        severity="warning"
        rounded
        onClick={exportPdf}
        data-pr-tooltip="PDF"
      />
    </div>
  );

  const startContent = (
    <div className="filtros">
      <div className="filtros-cols">
        <div className="filtros-col">
          <div className="filtros-item">
            <label htmlFor="data" className="font-bold">{t("dataInicial")}</label>
            <Calendar id="data" value={data} onChange={(e) => changeData(e.value)} showIcon dateFormat="dd/mm/yy" locale="pt" />
          </div>
          <div className="filtros-item">
            <label htmlFor="documento" className="font-bold">{t("documento")}</label>
            <InputText id="documento" maxLength={18} onKeyUp={handleDocumento} onBlur={(e) => changeDocumento(e.target.value)} placeholder="CPF, CNPJ ou Placa" />
          </div>
          <div className="filtros-item" style={{ visibility: state.user.cliente ? 'hidden' : 'visible' }}>
            <label htmlFor="cliente" className="font-bold">{t("cliente")}</label>
            <Dropdown inputId="cliente" disabled={state.user.cliente} value={selectedClient} onChange={(e) => { changeCliente(e.value) }} options={clients} optionLabel="name" placeholder="Selecione Cliente" showClear filter />
          </div>
          <div className="filtros-item" style={{ visibility: state.user.cliente ? 'hidden' : 'visible' }}>
            <label htmlFor="filtroErro" className="font-bold">{t("filtroErro")}</label>
            <Dropdown inputId="filtroErro" value={selectedErro} onChange={(e) => changeErro(e.value)} options={tiposErro} optionLabel="name" placeholder="Selecione" />
          </div>
        </div>
        <div className="filtros-col">
          <div className="filtros-item">
            <label htmlFor="dataFinal" className="font-bold">{t("dataFinal")}</label>
            <Calendar id="dataFinal" value={dataFinal} onChange={(e) => changeDataFinal(e.value)} showIcon dateFormat="dd/mm/yy" locale="pt" />
          </div>
          {state.user.funcoes.includes("CONSULTA_SUPER") && (
            <div className="filtros-item">
              <label htmlFor="usuario" className="font-bold">{t("usuario")}</label>
              <InputText id="usuario" onBlur={(e) => changeUsuario(e.target.value)} required />
            </div>
          )}
          <div className="filtros-item">
            <label htmlFor="opcao" className="font-bold">{t("opcao")}</label>
            <TreeSelect inputId="opcao" value={selectedNodeKey} options={createOptions()} onChange={(e) => changeOpcao(e.value)} filter showClear placeholder="Selecione opção"></TreeSelect>
          </div>
          <div className="filtros-item" style={{ visibility: state.user.cliente ? 'hidden' : 'visible' }}>
            <label htmlFor="filtroCache" className="font-bold">{t("filtroCache")}</label>
            <Dropdown inputId="filtroCache" value={selectedCache} onChange={(e) => changeCache(e.value)} options={tiposCache} optionLabel="name" placeholder="Selecione" />
          </div>
        </div>
      </div>
    </div>
  );

  const endContent = <React.Fragment></React.Fragment>;

  const downloadResponse = (consulta: any) => {
    getConsultaDownloadResponse(consulta.id).then((blobFile: Blob) => {
      const url = window.URL.createObjectURL(
        new Blob([blobFile], { type: "octet/stream" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `response.txt`);

      // Append to html link element page
      document.body.appendChild(link);

      // Start download
      link.click();

      // Clean up and remove the link
      document.body.removeChild(link);
    });
  };

  const visualizarTemplate = (consulta: any) => {
    return (
      <>
        {state.user.funcoes.includes("CONSULTA_CACHE_WEB") &&
          consulta.erro === "Não" &&
          consulta.cache.includes("Não") &&
          consulta.protocolo && (
            <Button
              icon="pi pi-window-maximize"
              onClick={() => {
                window.open("/creditbureau/consultar/" + consulta.id, "_blank");
              }}
              style={{
                background: "transparent",
                color: "gray",
                border: "none",
              }}
            />
          )}
      </>
    );
  };

  const downloadTemplate = (consulta: any) => {
    return (
      <>
        {state.user.funcoes.includes("CONSULTA_DOWNLOAD") &&
          consulta.erro === "Não" && (
            <Button
              icon="pi pi-download"
              onClick={() => {
                downloadResponse(consulta);
              }}
              style={{
                background: "transparent",
                color: "gray",
                border: "none",
              }}
            />
          )}

      </>
    );
  };



  useEffect(() => {
    const lazyClient = {
      first: 0,
      rows: 99999999,
      page: 1,
      cliente: 'null',
      documento: 'null',
      codigoClienteErp: null,
      inativo: null,
      idFranquia: state.user.franquiaSelected?.id ? state.user.franquiaSelected?.id : null,
      sortField: 'nome',
      sortOrder: SortOrder.DESC
    }
    const clientes: any[] = [];
    if (!state.user.cliente) {
      findClient(lazyClient).then(data => {
        data.clientes.forEach((c: { nome: string; id: string; }) => {
          clientes.push({ name: c.nome, code: c.id })
        })
      })
    }

    setClients(clientes);
  }, []);

  const rowExpansionTemplate = (data: any) => {

    return (
      <div>
        <DataTable value={data.filhos}>
          <Column field="data" sortable header={t('data')} />
          <Column field="dataRequisicao" sortable header={t('dataSolicitacao')} />
          <Column field="opcao" sortable header={t('opcaoConsulta')} />
          <Column field="erro" header={t('erro')} />
          <Column style={{ width: '11%' }} body={downloadTemplate} />
        </DataTable>
      </div>
    );
  };

  useEffect(() => {
    loadLazyData();
  }, [lazyState]);

  return (
    <Container>
      <div className="row">
        <div className="col-lg-12 mb-3">
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h3 mb-0 text-gray">
              <i className="pi pi-history" style={{ fontSize: "2.0rem" }}></i>{" "}
              {t("historicoConsulta")}
            </h1>
          </div>
        </div>
      </div>
      <div className="card">
        <Toolbar start={startContent} end={endContent} />
        <br></br>
        <br></br>
        <DataTable value={consultas} first={lazyState.first} dataKey="id" paginator={true} lazy={true}
          emptyMessage="Sem registros" header={header} expandedRows={expandedRows} onRowToggle={(e: any) => setExpandedRows(e.data)}
          rowExpansionTemplate={rowExpansionTemplate}
          onSort={onSort} sortField={lazyState.sortField} sortOrder={lazyState.sortOrder}
          rows={lazyState.rows} totalRecords={totalRecords} onPage={onPage}
          tableStyle={{ minWidth: '75rem' }}>
          <Column expander={true} style={{ width: '1.5rem' }} />
          <Column field="dataRequisicao" sortable header={t('dataSolicitacao')} />
          <Column field="ip" sortable header={t('ip')} />
          <Column field="protocolo" sortable header={t('protocolo')} />
          <Column field="documento" sortable header={t('filtro')} />
          <Column field="consumidor" header={t('consumidor')} />
          <Column field="cliente" header={t('cliente')} />
          <Column field="usuario" sortable sortField='usuario.nome' header={t('usuario')} />
          <Column field="agrupador" header={t("nomeComercial")} />
          <Column field="origem" sortable sortField='origemConsulta' header={t('origem')} />
          {!state.user.cliente && <Column field="cache" header={t('cache')} />}
          <Column field="valor" header={t('valor')} />
          <Column style={{ width: '11%' }} body={visualizarTemplate} />


        </DataTable>
      </div>
    </Container>
  );
}